import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import { PageUrl } from "src/routes/PageUrl";
import { makeUrl } from "src/routes/makeUrl";

export const breadItem = <T extends {} = {}>(
  title: string,
  url?: PageUrl,
  params?: T,
): BreadcrumbItemType => ({
  title,
  href: url ? makeUrl(url, params) : undefined,
});
